import AdditionalMenuView from './AdditionalMenuView';

export default AdditionalMenuView;
